import { useState } from 'react';
import { faqList } from '@/mocks/cinema';

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-1">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
              <i className="ri-question-line"></i>
              常见问题
            </span>
            <h2 className="mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">
              关于票房与排片，你想知道的都在这里
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              从数据口径到档期更新，从购票流程到投稿爆料，整理了你使用吃瓜影院时最关心的问题。
            </p>
            <a
              href="#about"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
            >
              联系与投稿
              <i className="ri-send-plane-line"></i>
            </a>
          </div>

          <div className="lg:col-span-2">
            <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {faqList.map((f, i) => {
                const open = openIdx === i;
                return (
                  <div key={f.q}>
                    <button
                      type="button"
                      onClick={() => setOpenIdx(open ? -1 : i)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                    >
                      <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                        {f.q}
                      </span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-transform ${
                          open ? 'rotate-45 bg-primary-100 text-primary-700' : ''
                        }`}
                      >
                        <i className="ri-add-line"></i>
                      </span>
                    </button>
                    {open && (
                      <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}